import React from 'react';
import classNames from 'classnames';
import { ProfileOutlined } from 'jl-design-system/components/icons/ProfileOutlined';
import styles from './account-button.scss';

export const AccountButton = ({
  onClick,
  greeting,
  isTabbedNavActive,
  myAccountUrl,
  isMobileBoostWishlistActive,
}) => {
  let accountText = 'Account';
  if (isMobileBoostWishlistActive && !greeting) accountText = 'Sign in';

  return (
    <a
      href={myAccountUrl || '/my-account'}
      onClick={onClick}
      data-test="account-button"
      data-testid="account-button"
      className={classNames(styles.container, {
        [styles.container__tn]: isTabbedNavActive,
      })}
      aria-label="Go to your account"
    >
      {greeting && (
        <span
          className={classNames(styles.greeting, {
            [styles.greeting__tn]: isTabbedNavActive,
          })}
        >
          {greeting}
        </span>
      )}
      <ProfileOutlined
        className={styles.icon}
        dataTestId="account-button-icon"
        size="medium"
      />
      <span
        className={classNames(styles.label, {
          [styles.label__tn]: isTabbedNavActive,
        })}
      >
        {accountText}
      </span>
    </a>
  );
};
